export enum NotificationEvents {
  InspectionReleased = "InspectionReleased",
  VideoAnalysisFinished = "VideoAnalysisFinished",
  VideoConversionFinished = "VideoConversionFinished",
  VideoSegmentationFinished = "VideoSegmentationFinished",
  VideoOcrFinished = "VideoOcrFinished",
  InspectionFileUploadFinished = "InspectionFileUploadFinished",
  OrganizationCollaborationStopped = "OrganizationCollaborationStopped",
  FeatureFlagsChanged = "FeatureFlagsChanged",
}
